import { getOptionById } from "./getDemoData"

export const uniqueStrings = (values: (string | undefined)[]) => [
  ...new Set(values.filter((value): value is string => !!value))
]

// Option values come from labels like "Code & command execution"; API keys look
// like "code_and_command_execution". Both normalize to "code-command-execution".
export const normalizeOptionValue = (value: string) =>
  value
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((token) => token && token !== "and")
    .join("-")

// Maps observed labels (tool names, categories, vendors) onto a rule option's
// values. A candidate without a matching option keeps its normalized form, so a
// tool the option list does not know still becomes a rule value.
export const toOptionValues = (ruleId: string, candidates: string[]) => {
  const options = getOptionById(ruleId)?.options ?? []
  const byLabel = new Map(
    options.map((option) => [normalizeOptionValue(option.label), option.value])
  )
  const byValue = new Set(options.map((option) => option.value))

  return uniqueStrings(
    candidates.map((candidate) => {
      const normalized = normalizeOptionValue(candidate)

      if (byValue.has(normalized)) return normalized

      return byLabel.get(normalized) ?? normalized
    })
  )
}

export const toOptionLabel = (ruleId: string, value: string) =>
  getOptionById(ruleId)?.options.find((option) => option.value === value)
    ?.label ?? value
